import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import o, { createContext as H, useContext as E, useEffect as m, useState as u } from "react";
import { createPortal as g } from "react-dom";
import { useDisposables as h } from '../hooks/use-disposables.js';
import { objectToFormEntries as x } from '../utils/form.js';
import { compact as y } from '../utils/render.js';
import { Hidden as l, HiddenFeatures as d } from './hidden.js';
var f = H(null);
function W(t) {
  var _u = u(null),
    _u2 = _slicedToArray(_u, 2),
    e = _u2[0],
    r = _u2[1];
  return o.createElement(f.Provider, {
    value: {
      target: e
    }
  }, t.children, o.createElement(l, {
    features: d.Hidden,
    ref: r
  }));
}
function c(_ref) {
  var t = _ref.children;
  var e = E(f);
  if (!e) return o.createElement(o.Fragment, null, t);
  var r = e.target;
  return r ? g(o.createElement(o.Fragment, null, t), r) : null;
}
function j(_ref2) {
  var t = _ref2.data,
    e = _ref2.form,
    r = _ref2.disabled,
    n = _ref2.onReset,
    F = _ref2.overrides;
  var _u3 = u(null),
    _u4 = _slicedToArray(_u3, 2),
    i = _u4[0],
    a = _u4[1],
    p = h();
  return m(function () {
    if (n && i) return p.addEventListener(i, "reset", n);
  }, [i, e, n]), o.createElement(c, null, o.createElement(C, {
    setForm: a,
    formId: e
  }), x(t).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      s = _ref4[0],
      v = _ref4[1];
    return o.createElement(l, _objectSpread({
      features: d.Hidden
    }, y(_objectSpread({
      key: s,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: e,
      disabled: r,
      name: s,
      value: v
    }, F))));
  }));
}
function C(_ref5) {
  var t = _ref5.setForm,
    e = _ref5.formId;
  return m(function () {
    if (e) {
      var r = document.getElementById(e);
      r && t(r);
    }
  }, [t, e]), e ? null : o.createElement(l, {
    features: d.Hidden,
    as: "input",
    type: "hidden",
    hidden: !0,
    readOnly: !0,
    ref: function ref(r) {
      if (!r) return;
      var n = r.closest("form");
      n && t(n);
    }
  });
}
export { j as FormFields, W as FormFieldsProvider, c as HoistFormFields };